'use client'

import { BounceLoader } from 'react-spinners'

export default function ProtectedLoading() {
    return (
        <div className='flex min-h-full items-center justify-center'>
            <BounceLoader />
        </div>
    )
}
